import { useCallback } from "react";
import { parseISO, isValid, isEqual, isAfter, addMonths, startOfToday, startOfDay } from "date-fns";

// const useValidateDate = () => {
//   const validateDate = useCallback((dateString: string | null | undefined): string => {
//     if (!dateString || typeof dateString !== "string") {
//       return "";
//     }
//     const date = new Date(dateString);
//     const today = new Date();

//     // Set today's time to midnight for comparison
//     today.setHours(0, 0, 0, 0);
//     date.setHours(0, 0, 0, 0);

//     // Check if date is today or in the future
//     return date >= today ? dateString : "";
//   }, []);

//   return validateDate;
// };

// export default useValidateDate;

const useValidateDate = () => {
  const validateDate = useCallback((dateString: string | null | undefined): string => {
    const today = startOfToday();
    const nextMonthDate = `${addMonths(today, 1).toISOString().split("T")[0]}T00:00:00Z`;

    if (!dateString || typeof dateString !== "string") {
      return nextMonthDate;
    }

    const date = parseISO(dateString);

    if (!isValid(date)) {
      return nextMonthDate;
    }

    const dateAtStartOfDay = startOfDay(date);

    if (isEqual(dateAtStartOfDay, today) || isAfter(dateAtStartOfDay, today)) {
      return dateString;
    }

    return nextMonthDate;
  }, []);

  return validateDate;
};

export default useValidateDate;
